import { render } from "./LocationsAdd.vue?vue&type=template&id=0f24b174"
import script from "./LocationsAdd.vue?vue&type=script&lang=js"
export * from "./LocationsAdd.vue?vue&type=script&lang=js"
script.render = render

export default script